/** Dominios de correo que pueden entrar. Todo lo demás se rechaza aunque Google lo autentique. */
export const DOMINIOS_PERMITIDOS = ["vanguardia.com.mx"] as const;

export function dominioPermitido(
  correo: string | undefined | null,
  extra: readonly string[] = [],
): boolean {
  if (!correo) return false;
  const dominio = correo.trim().toLowerCase().split("@")[1];
  if (!dominio) return false;
  return [...DOMINIOS_PERMITIDOS, ...extra].some((d) => d.toLowerCase() === dominio);
}
